(function() {
	'use strict';
	angular.module('app.setup')
		.controller('dropdownValues', dropdownValues);

	dropdownValues.$inject = ['$rootScope', '$scope', '$timeout', '$compile', '$uibModal', 'projectCustomFieldsService', 'storeService'];
	
	function dropdownValues($rootScope, $scope, $timeout, $compile, $uibModal, projectCustomFieldsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.customFieldNdx = $scope.customFieldNdx;
		vm.customFieldName = $scope.customFieldName;
		vm.dropdownValues = [];
		// view model functions
		vm.showEdit = showEdit;
		vm.cancelEdit = cancelEdit;
		vm.saveEdit = saveEdit;
		vm.close = close;
		vm.updateField = updateField;
		vm.addFieldValue = addFieldValue;
		vm.deleteFieldValue = deleteFieldValue;
		getDropdownValues();
	
		function getDropdownValues() {
			projectCustomFieldsService.getDropDownValues(vm.customFieldNdx, adminConfig.customer.id).then(function(response){
				var dropdownValues = response;
				if (dropdownValues.data && dropdownValues.data.length) {
					vm.dropdownValues = dropdownValues.data;
				} else {
					vm.dropdownValues = [];
				}
			});
		}

		function updateField() {
			if (vm.field.fieldType === 'DROPDOWN') {
				vm.isDropDownField = true;
			} else {
				vm.isDropDownField = false;
			}
			vm.field.dropdownValues = [];
		}
		
		function close() {
			$scope.result('', false);
		}
		
		function isValueAreadyExists() {
			return vm.dropdownValues.map(function (item) {
	            return item.fieldValue.toLowerCase();
	        }).indexOf(vm.fieldValue.toLowerCase());
		}
		
		function addFieldValue() {
			if (vm.fieldValue && isValueAreadyExists() === -1) {
				var saveObj = {};
				saveObj['fieldValue'] = vm.fieldValue;
				projectCustomFieldsService.addDropDownFieldValue(vm.customFieldNdx, saveObj, adminConfig.customer.id)
				.then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {'message': 'Dropdown Field Value was saved successfully', 'success': true});
						getDropdownValues();
					} else if (response && response.status === 412) {
						var errorMessage = 'This custom field has been updated since you last loaded the page, please refresh the page';
						if (response && response.data && response.data.error) {
							errorMessage = response.data.error;
						}
						$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
					} else {
						$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
					}
				});
			}
		}
		
		function deleteFieldValue(index) {
			var confirmScope = $scope.$new();
			confirmScope.valueNdx = vm.dropdownValues[index].ndx;
			confirmScope.additionalText = 'delete this value';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var valueNdx = confirmScope.valueNdx;
				instance.close();
				confirmScope.$destroy();
				projectCustomFieldsService.deleteDropDownValue(valueNdx, adminConfig.customer.id).then(function(message) {
					var isSuccessful = (message == 'Custom field deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						getDropdownValues();
					}
				});
			};
		}
		
		function getTemplate(position, rowIndex) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			position.left = 20;
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var header = 'Edit Value';
			var scopeModal = 'dropdownValuesCtrl.editFieldValue';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + header + '</div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="' + scopeModal + '" />' +
				'<span class="input-clear" ng-show="' + scopeModal + ' && ' + scopeModal + '.length" ng-click="' + scopeModal + ' = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="dropdownValuesCtrl.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="(' + scopeModal + ' && ' + scopeModal + '.length>0) && ' + 'dropdownValuesCtrl.saveEdit(' + rowIndex + ')">Save</a></div></div>';
			return editTemplate;
		}
		
		function showEdit(index) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#fieldValue' + index);
			var pos = cell.offset();

			var content = cell.text();
			var editTemplate = getTemplate(pos, index);
			var compiledDiv = $compile(editTemplate)($scope);
			vm.editFieldValue = content;
			
			jQuery('#customFieldForm').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					if (vm.editFieldValue == null || strip(vm.editFieldValue) === '') {
						return;
					}
					vm.saveEdit(index, type);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		
		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		function saveEdit(index) {
			var content = strip(vm.editFieldValue);	
			var saveObj = {};
			saveObj.ndx = vm.dropdownValues[index].ndx;
			var tempField = vm.dropdownValues[index].fieldValue;
			
			if (tempField != content) {
				saveObj['fieldValue'] = content;
				projectCustomFieldsService.updateDropDownFieldValue(vm.customFieldNdx, saveObj, adminConfig.customer.id)
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Dropdown Field Value was saved successfully', 'success': true});
							getDropdownValues();
						} else if (response && response.status === 412) {
							var errorMessage = 'This custom field has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
			vm.cancelEdit();
		}
	}
})();
